<section class="pricing-lever-slider">
  <h3 class="pricing-lever-slider__title">
    {{ data?.title || 'Pricing lever' }}
    <span class="pricing-lever-slider__highlight" *ngIf="data?.highlightText">
      {{ data?.highlightText }}
    </span>
  </h3>

  <ng-container *ngIf="configReady; else missingConfig">
  <div class="pricing-lever-slider__track-row">
    <span class="pricing-lever-slider__range-label">{{ formattedMin }}</span>
    <mat-slider class="pricing-lever-slider__slider" [min]="min!" [max]="max!" [step]="step!">
      <input
        matSliderThumb
        [ngModel]="value"
        [disabled]="!userInputEnabled"
        (ngModelChange)="onSliderInput($event)"
        (dragEnd)="onSliderCommit($event)"
      />
    </mat-slider>
    <span class="pricing-lever-slider__range-label">{{ formattedMax }}</span>
  </div>

  <div class="pricing-lever-slider__value">{{ formattedValue }}</div>
  <button
    *ngIf="userInputEnabled && hasPendingSubmit"
    type="button"
    class="pricing-lever-slider__submit"
    [disabled]="isSubmitting"
    (click)="onSubmitClick()"
  >
    {{ isSubmitting ? 'Submitting...' : submitButtonLabel }}
  </button>
  </ng-container>

  <ng-template #missingConfig>
    <div class="pricing-lever-slider__error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </ng-template>
</section>

<div
  class="pricing-lever-slider__confirm-backdrop"
  *ngIf="showSubmitConfirmation"
  (click)="onCancelSubmit()"
>
  <div
    class="pricing-lever-slider__confirm-dialog"
    (click)="$event.stopPropagation()"
  >
    <div class="pricing-lever-slider__confirm-note">
      <span class="pricing-lever-slider__confirm-note-label">{{ submitConfirmationNoteLabel }}</span>
      <span class="pricing-lever-slider__confirm-note-body"> {{ submitConfirmationNoteBody }}</span>
    </div>
    <div class="pricing-lever-slider__confirm-actions">
      <button
        type="button"
        class="pricing-lever-slider__confirm-btn pricing-lever-slider__confirm-btn--no"
        (click)="onCancelSubmit()"
      >
        {{ confirmNoLabel }}
      </button>
      <button
        type="button"
        class="pricing-lever-slider__confirm-btn pricing-lever-slider__confirm-btn--yes"
        (click)="onConfirmSubmit()"
      >
        {{ confirmYesLabel }}
      </button>
    </div>
  </div>
</div>
